import { LitElement, html, nothing } from "lit";

import { customElement, property } from "lit/decorators.js";

import { dropdownMenuItemStyles } from "./dropdown-menu-item.css";

@customElement("dropdown-menu-item")
export class DropdownMenuItem extends LitElement {
  static override styles = [dropdownMenuItemStyles];

  @property({ type: String }) label = "";
  @property({ type: String }) action = "";
  @property({ type: String, reflect: true }) variant: "default" | "danger" = "default";
  @property({ type: String, attribute: "icon-position" }) iconPosition: "start" | "end" = "end";
  @property({ type: Boolean, reflect: true }) disabled = false;

  private handleClick = (e: Event) => {
    if (this.disabled) {
      e.preventDefault();
      return;
    }

    // Dispatch custom event with action details
    this.dispatchEvent(
      new CustomEvent("dropdown-item-click", {
        detail: {
          action: this.action,
          label: this.label,
        },
        bubbles: true,
        composed: true,
      }),
    );
  };

  private handleKeyDown = (e: KeyboardEvent) => {
    if ((e.key === "Enter" || e.key === " ") && !this.disabled) {
      e.preventDefault();
      this.handleClick(e);
    }
  };

  protected override render() {
    return html`
      <button
        class="dropdown-menu-item"
        type="button"
        role="menuitem"
        @click=${this.handleClick}
        @keydown=${this.handleKeyDown}
        ?disabled=${this.disabled}
        tabindex="0"
      >
        ${this.iconPosition === "start" ? html`<slot name="icon"></slot>` : nothing}
        ${this.label
          ? html`<span class="dropdown-menu-item-label">${this.label}</span>`
          : html`<span class="dropdown-menu-item-label"><slot></slot></span>`}
        ${this.iconPosition === "end" ? html`<slot name="icon"></slot>` : nothing}
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "dropdown-menu-item": DropdownMenuItem;
  }
}
